<template>
  <div class>
    <div class="wd-100p">
      <RadioGroup v-model="createdUser.mode" @change="createdUserChanged">
        <Radio label="1">
          <span>Нэвтрэх нэр (Бүртгэл №)</span>
        </Radio>
        <Radio label="2">
          <span>Регистр №</span>
        </Radio>
        <Radio label="3">
          <span>Нэр</span>
        </Radio>
      </RadioGroup>
    </div>
    <div class="wd-100p">
      <Input
        v-model="createdUser.value"
        @change="createdUserFind"
        search
        enter-button="Хайх"
        suffix-icon="search"
      />
    </div>
    <div class="wd-100p">
      <template v-if="createdUser.curId != 0">
        <template v-if="createdUser.list.length > 0">
          <div
            v-if="
              createdUser.list.filter(x => x.id == createdUser.curId).length > 0
            "
            role="alert"
            class="alert alert-info d-flex align-items-center mg-t-10"
            @click="handleUserInfoModal(createdUser.curId)"
          >
            <feather
              type="user"
              size="14"
              class="mg-r-5"
              style="min-width: 14px"
            ></feather>
            {{
              createdUser.list.filter(x => x.id == createdUser.curId)[0]
                .fullName
            }}
            /
            {{
              createdUser.list.filter(x => x.id == createdUser.curId)[0]
                .loginName
            }}
          </div>
          <button
            @click="
              createdUser.value = '';
              createdUser.curId = 0;
              $emit('input', null);
            "
            type="button"
            class="btn btn-xs btn-danger text-white d-flex"
          >
            <span>Хайсан утгыг арилгах</span>
            <feather type="x" size="14" class="mg-l-5 mg-t-4"></feather>
          </button>
        </template>
      </template>
      <template>
        <div
          v-if="createdUser.curId == 0"
          role="alert"
          class="alert alert-warning d-flex align-items-center mg-t-10"
        >
          Хайх утгаа оруулна уу.
        </div>
      </template>
    </div>

    <b-modal
      size="lg"
      v-model="createdUser.modal"
      title="Хэрэглэгч сонгох"
      @hide="cancel()"
      hide-footer
      centered
      body-class="pd-0"
    >
      <div style="overflow: auto; height: 70vh;">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">№</th>
              <th scope="col">Төрөл</th>
              <th scope="col">Нэр</th>
              <th scope="col">Нэвтрэх нэр (Бүртгэл №)</th>
              <th scope="col">Регистр №</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="handleUserInfoModal(u.id)"
              v-for="(u, i) in createdUser.list"
              :key="i"
              class="is-pointer"
              role="button"
            >
              <td scope="row">{{ i + 1 }}</td>
              <td>{{ u.locType4Name }}</td>
              <td>{{ u.fullName }}</td>
              <td>{{ u.loginName }}</td>
              <td>{{ u.register }}</td>
              <td>
                <button
                  @click.stop="
                    $emit('input', u.userId);
                    createdUser.curId = u.id;
                    createdUser.modal = false;
                  "
                  type="button"
                  class="btn btn-xs btn-outline-primary d-flex"
                >
                  <feather
                    type="check"
                    size="14"
                    class="mg-l-5 mg-t-4"
                  ></feather>
                  <span>Сонгох</span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { Input, RadioGroup, Radio } from "element-ui";

import { request } from "@/api/all";
import { mapActions } from "vuex";

export default {
  components: {
    RadioGroup,
    Radio,
    Input
  },
  data() {
    return {
      createdUser: {
        mode: "1",
        value: "",
        list: [],
        modal: false,
        curId: 0
      }
    };
  },

  methods: {
    ...mapActions(["handleLoading", "handleUserInfoModal"]),
    cancel() {
      this.createdUser.modal = false;
    },
    createdUserChanged(e) {
      this.createdUser.mode = e;
    },
    createdUserFindAfter(res) {
      this.createdUser.list = res.data.users;
      if (this.createdUser.list.length > 0) {
        if (this.createdUser.list.length == 1) {
          this.$emit("input", res.data.users[0].userId);
          this.createdUser.curId = res.data.users[0].id;
          this.createdUser.modal = false;
        } else {
          this.createdUser.modal = true;
        }
      }
    },
    createdUserFind() {
      if (this.createdUser.mode == "1") {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "GET", url: "Hr/GetUsersByLoginName" },
          params: {
            loginName: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "2") {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "GET", url: "Hr/GetUsersByLoginName" },
          params: {
            register: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      } else if (this.createdUser.mode == "3") {
        this.handleLoading({ isLoading: true });
        request({
          api: { method: "GET", url: "Hr/GetUsersByFirstName" },
          params: {
            firstName: this.createdUser.value
          },
          store: this.$store
        }).then(res => {
          this.handleLoading({ isLoading: false });
          if (res != false) {
            this.createdUserFindAfter(res);
          }
        });
      }
    }
  }
};
</script>
